"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var typographyTokensWeight = _styleUtilities.typography.weight;

var typography = function typography(_ref) {
  var theme = _ref.theme,
      desktop = _ref.desktop,
      mobile = _ref.mobile,
      color = _ref.color,
      weight = _ref.weight;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n\n  ", "\n\n  ", ";\n"])), _styleUtilities.typography[mobile](theme), _styleUtilities.palette[color](theme), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), _styleUtilities.typography[desktop](theme)), weight && typographyTokensWeight[weight](theme));
};

var Typography = _stylitas.styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), typography);

exports.Typography = Typography;